import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../lib/utils.js";

const surfaceVariants = cva("text-foreground", {
  variants: {
    variant: {
      plain: "bg-transparent",
      divided: "border-y bg-transparent",
      outlined: "rounded-surface border bg-surface",
      interactive:
        "rounded-surface border bg-surface transition-colors duration-fast ease-operational hover:border-primary/30 hover:bg-surface-subtle focus-within:border-primary/40",
      elevated: "rounded-surface border bg-surface-raised shadow-md",
    },
  },
  defaultVariants: {
    variant: "plain",
  },
});

export interface SurfaceProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof surfaceVariants> {}

export const Surface = React.forwardRef<HTMLDivElement, SurfaceProps>(
  ({ className, variant, ...props }, ref) => (
    <div ref={ref} className={cn(surfaceVariants({ variant }), className)} {...props} />
  ),
);
Surface.displayName = "Surface";

export { surfaceVariants };
